/**
 * Usage:
 * <template>
 *   <div ref="target" @dbltouch="callback"></div>
 * </template>
 * <script>
 *   // on mounted (required)
 *   const el = this.$refs.target
 *   useDbltouch(el)
 *   // add listener manually or set @dbltouch on the element
 *   el.addEventListener('dbltouch', callback)
 * </script>
 *
 * Event:
 * dbltouch (e) // e.detail.event = original touchend event
 */

export const useDbltouch = (el, acceptedInterval = 300) => {
  let timeout
  let lastTouch = 0
  let touching = 0
  el.addEventListener('touchstart', e => {
    const time = new Date().getTime()
    const touchInterval = time - lastTouch
    clearTimeout(timeout)
    touching++
    if (touchInterval < acceptedInterval && touchInterval > 0) {
      // Double touch
      e.preventDefault()
      if (touching > 1) { // Prevent multiple touch at the same time
        return
      }
      const event = new CustomEvent('dbltouch', {
        detail: {
          interval: touchInterval,
          event: e
        }
      })
      el.dispatchEvent(event)
    } else {
      // Single touch
      timeout = setTimeout(() => {
        clearTimeout(timeout)
      }, acceptedInterval)
    }
    lastTouch = time
  })
  el.addEventListener('touchend', e => {
    touching--
  })
}
